// extracted by mini-css-extract-plugin
export var boxItems = "_ak-1";
export var boxItemsLg = "_ak-2";
export var button = "_ak-7";
export var buttonHoverless = "_ak-9";
export var buttonLg = "_ak-8";
export var filterGroupBox = "_ak-0";
export var icon = "_ak-3";
export var iconSecondary = "_ak-6";
export var iconWrapper = "_ak-4";
export var iconWrapperLg = "_ak-5";
export var truncatedLabel = "_ak-a";